<template>
  <div class="article-body-text">
    <div v-html="item.content.html" ref="body-html"></div>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import forEach from 'lodash/forEach'

  export default {
    name: 'body-text',
    props: ['item'],
    mounted() {
      const bodyHtml = get(this, '$refs[body-html]')
      // bypass url protocol (ignore http and https)
      const currentDomain = get(this, '$store.state.requestDomain', '').replace(/^https?:\/\//i, '')
      const regexp = new RegExp(currentDomain, 'gi')

      if (bodyHtml) {
        forEach(bodyHtml.querySelectorAll('a'), (value) => {
          // if href not match hostname and not a relative link
          if (!value.getAttribute('href').match(regexp) && !value.getAttribute('href').match(/^\//i)) {
            // No need _blank for emails
            if (!value.getAttribute('href').match(/mailto:/gi)) {
              value.setAttribute('target', '_blank')
            }
          }
        })
      }
    },
  }
</script>





// WEBPACK FOOTER //
// Text.vue?19139a75